import { T } from '@/libs/translation';
import { Button, Icon, Typo } from '@/ui/component/atom';
import { Modal } from '@/ui/component/cell';
import { ChangePasswordModalBodyView, SetPasswordModalBodyView } from '@/ui/component/view';
import { html, View } from 'rune-ts';
import klass from './SetPassword.module.scss';

export class SetPasswordView extends View<{ email: string; hasPassword?: boolean }> {
  private changePasswordButton = new Button(
    {
      label: new Typo({ text: T('mypage.button.008') }, { typo: 'p2', weight: 'bold' }),
    },
    { type: 'button', size: 'small', color: 'secondary' },
  );

  private setPasswordButton = new Button(
    {
      label: new Typo({ text: T('mypage.button.004') }, { typo: 'p2', weight: 'bold' }),
    },
    { type: 'button', size: 'small', color: 'primary' },
  );

  protected override template() {
    const { hasPassword } = this.data;

    return html`<div>
      <div>${hasPassword ? this.changePasswordButton : this.setPasswordButton}</div>
      ${hasPassword
        ? ''
        : html`<div class="${klass.field_description_info}">
            ${new Icon({ name: 'info', size: 20 })}
            <div>${new Typo({ text: T('mypage.description.password.001') }, { typo: 'p2' })}</div>
          </div>`}
    </div>`;
  }

  async openSetPasswordModal() {
    await Modal.open(
      { view: new SetPasswordModalBodyView({ email: this.data.email }) },
      {
        header: {
          title: T('mypage.set_password.title.001'),
        },
        footer: {
          cancel: T('mypage.set_password.button.001'),
          confirm: T('mypage.set_password.button.002'),
          confirm_option: {
            color: 'primary',
            disabled: true,
          },
        },
        backdrop: true,
        append_to: this.parentView?.element(),
      },
    );
  }

  override onRender() {
    this.delegate('click', Button, async (e, view) => {
      if (this.subViews(Button).includes(view)) {
        if (this.data.hasPassword) {
          const res = await Modal.open(
            { view: new ChangePasswordModalBodyView({ email: this.data.email }) },
            {
              header: {
                title: T('mypage.change_password.title.001'),
              },
              footer: {
                cancel: T('mypage.change_password.button.001'),
                confirm: T('mypage.change_password.button.002'),
                confirm_option: {
                  color: 'primary',
                  disabled: true,
                },
              },
              backdrop: true,
              append_to: this.parentView?.element(),
            },
          );

          if (res === 'confirm') {
            this.data.hasPassword = true;
            this.redraw();
          }
        } else {
          await this.openSetPasswordModal();
        }
      }
    });
  }
}
